// import {
//   FormControl,
//   FormControlLabel,
//   FormLabel,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { ForwardedRef, forwardRef, useState } from "react";
import { AppRadioButtonProps } from "./AppRadioButtons.props";
import { AppRadioButtonStyles } from "./AppRadioButton.styles";
import React from "react";
import { OptionsI } from "../../../@types/FormFields";

const AppRadioButton = forwardRef(function AppRadioButton(
  {
    label,
    value,
    options = [],
    required = false,
    onChange = () => {},
    readOnly = false,
    isInRow = true,
    className = "",
    fontFamilyForLabel = "",
    fontFamilyForInput = "",
    ...otherProps
  }: AppRadioButtonProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  const StyleClasses = AppRadioButtonStyles();
  const [hasSeenTheOption, setHasSeenTheOption] = useState<boolean>(false);

  const effectiveFontLabel =
    fontFamilyForLabel || "MBCorpoAScreen1Cond-Regular-Web";
  const effectiveFontInput = fontFamilyForInput || effectiveFontLabel;

  return (
    <div className={className}>
      <FormControl fullWidth className={StyleClasses.default}>
        <FormLabel>
          <span
            style={{
              color: "white",
              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            }}
          >
            {label}
          </span>
          <span style={{ color: "white" }}>
            {required && label && <span className="text-red-600"> *</span>}
          </span>
        </FormLabel>
        <RadioGroup
          row={isInRow}
          onChange={(e, value) => {
            onChange(value, e);
          }}
          {...otherProps}
          value={value || ""}
        >
          {options.map((el: string | OptionsI, index) => {
            let optionLabel: string = el.toString();
            let optionValue: string = el.toString();
            if (typeof el !== "string") {
              optionLabel = el.label;
              optionValue = el.value?.toString() || el.label;
            }
            if (!hasSeenTheOption && optionValue == value) {
              setHasSeenTheOption(true);
            }
            return (
              <FormControlLabel
                name={optionLabel}
                disabled={readOnly}
                value={optionValue}
                control={
                  <Radio
                    required={
                      (value != "false" && value != "") || hasSeenTheOption
                        ? false
                        : required
                    }
                    inputRef={ref}
                    sx={{
                      fontFamily: effectiveFontInput,
                      "&.MuiRadio-root": {
                        color: "#D9D9D9",
                        opacity: "rgba(0, 173, 239, 21)",
                      },
                      "&.Mui-checked": {
                        color: "#00ADEF",
                        borderColor: "#00ADEF",
                        stroke: "#D9D9D9",
                        strokeWidth: 2,
                      },
                    }}
                  />
                }
                label={
                  <span
                    style={{ color: "white", fontFamily: effectiveFontLabel }}
                  >
                    {optionLabel}
                  </span>
                }
                key={index}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  );
});
const AppSeparatedRadioButton = forwardRef(function AppSeparatedRadioButton(
  { label, options, required, readOnly = false }: AppRadioButtonProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  const StyleClasses = AppRadioButtonStyles();
  return (
    <FormControl fullWidth className={StyleClasses.separated}>
      <FormLabel>{label}</FormLabel>
      <RadioGroup ref={ref}>
        {options.map((el, index) => {
          return (
            <FormControlLabel
              disabled={readOnly}
              value={el}
              control={<Radio required={required} />}
              label={el}
              key={index}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
});

export { AppRadioButton, AppSeparatedRadioButton };
